import { useLocal } from '@/pages/dashboard/utils/customHook';

const Result = (props) => {
  const {
    value: { type = '', value = [] },
    alignedBy,
  } = props;
  const { isEN, locale, getLocalText } = useLocal();
  const prefix = type?.slice?.(0, 1)?.toUpperCase?.();

  return (
    <div className="range-day-month-selector-result">
      <span className="range-day-month-selector-result-value">
        <span className="text-desc"> {getLocalText(alignedBy?.textId || 'competitor_launch')}</span>{' '}
        {prefix}
        {value[0]} <i>~</i> {prefix}
        {value[1]}
      </span>
      {/* <span className='range-day-month-selector-result-type'>{getLocalText(`competitor_launch_${type}`)}</span> */}
    </div>
  );
};

export default Result;
